import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useDocsFilterStore } from "../stores";
import { useThemesList } from "@/features/themes/hooks/useThemesList";

const ALL_TOPICS_VALUE = "__all__";

const DocsTopicFilter = () => {
  const { t } = useTranslation();
  const { topicId, setTopicId } = useDocsFilterStore();
  const { themes, isLoading } = useThemesList();

  const handleChange = (val: string) =>
    setTopicId(val === ALL_TOPICS_VALUE ? null : val);

  return (
    <Select
      value={topicId ?? ALL_TOPICS_VALUE}
      onValueChange={handleChange}
      disabled={isLoading}
    >
      <SelectTrigger className="w-44 shrink-0">
        <SelectValue placeholder={t("modules.docs.keys.all_topics")} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL_TOPICS_VALUE}>
          {t("modules.docs.keys.all_topics")}
        </SelectItem>
        {themes
          .filter((theme) => theme.status === "active")
          .map((theme) => (
            <SelectItem key={theme.id} value={theme.id}>
              {theme.name}
            </SelectItem>
          ))}
      </SelectContent>
    </Select>
  );
};

export default DocsTopicFilter;
